import React, { Component } from 'react';
import {
  Button,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  Col,
  Container,
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Row
} from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';
import { push as routerPush } from 'react-router-redux';
import { Link } from 'react-router-dom';
import URI from 'urijs';
import numeral from 'numeral';
import FontAwesome from 'react-fontawesome';
import cx from 'classnames';

// ducks
import { LOAD as loadStats } from '../../ducks/Home';

// images
import imgSplash from './images/splash.jpg';
import imgWaterfront from './images/waterfront.jpg';
import imgGolf from './images/golf.jpg';
import imgRental from './images/rental.jpg';
import imgNaples from './images/naples.jpg';

// modules
import styles from '../Containers.module.scss';
import BS from '../../theme/Bootstrap';

// contianers
import HomeSearchForm from './HomeSearchForm';
import { BlogList } from '../../components/blog/list';
import ResponsiveCarousel from '../../components/carousel/carousel';

class Home extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values, dispatch, props) {
    return this.props.handleSubmit(values);
  }

  render() {
    const { stats, loading, loaded } = this.props;

    return (
      <div className={styles.Home}>
        <div className={styles.splash}>
          <div className={styles.imgWrap}>
            <div className={styles.imgWrapInner}>
              <img src={imgSplash} alt="Long dock off of a beach" />
            </div>
          </div>
          <Container>
            <div className={`${styles.splashStats} ${BS.textRight} ${BS.pt4} ${BS.pr2}`}>
              Naples, Florida
              <br />
              {loading && <FontAwesome name="spinner" spin />}
              {loaded && `${Math.round(stats.get('temp'))}° F / ${stats.get('weather')}`}
            </div>
            <h1>Find your dream home in paradise!</h1>
            <HomeSearchForm onSubmit={this.handleSubmit} />
          </Container>
        </div>
        <Navbar color="blue-dark" dark className={styles.afterSplash}>
          <Nav className="m-auto" navbar>
            <LinkContainer to="/find-naples-home/advanced">
              <NavItem>
                <NavLink href="/find-naples-home/advanced">
                  <span className={`${BS.fontWeightBold}`}>Advanced Search</span>
                  <Button color="secondary" size="sm" className={styles.goButton}>
                    <MaterialIcon icon="search" size="tiny" />
                  </Button>
                </NavLink>
              </NavItem>
            </LinkContainer>
          </Nav>
        </Navbar>
        <div className={styles.statsContainer}>
          <Container>
            <h2 className={BS.textCenter}>Naples Area Real Estate Market</h2>
            <Row>
              <Col xs={6} md={3}>
                <h3>
                  {loading && <FontAwesome name="spinner" spin />}
                  {loaded && numeral(stats.get('numNewListings')).format('0,0')}
                  <br />
                  <small>New Listings</small>
                </h3>
              </Col>
              <Col xs={6} md={3}>
                <h3>
                  {loading && <FontAwesome name="spinner" spin />}
                  {loaded && numeral(stats.get('numForSale')).format('0,0')}
                  <br />
                  <small>Properties for Sale</small>
                </h3>
              </Col>
              <Col xs={6} md={3}>
                <h3>
                  {loading && <FontAwesome name="spinner" spin />}
                  {loaded && numeral(stats.get('numOpenHouses')).format('0,0')}
                  <br />
                  <small>Open Houses</small>
                </h3>
              </Col>
              <Col xs={6} md={3}>
                <h3>
                  {loading && <FontAwesome name="spinner" spin />}
                  {loaded && numeral(stats.get('numCommercial')).format('0,0')}
                  <br />
                  <small>Commercial Properties</small>
                </h3>
              </Col>
            </Row>
          </Container>
        </div>
        <div className={styles.quickSearch}>
          <Container>
            <h2 className={BS.textCenter}>Quick Searches</h2>
            <Row>
              <Col xs={12} md={4}>
                <Card
                  tag={Link}
                  to="/find-naples-home?waterfrontYN=1"
                  className={styles.quickSearchCard}
                >
                  <CardBody className={styles.quickSearchCardBody}>
                    <CardTitle>Waterfront Properties</CardTitle>
                  </CardBody>
                  <CardImg tag="div" className={styles.quickSearchCardImg}>
                    <div className={styles.imgWrap}>
                      <div className={styles.imgWrapInner}>
                        <img alt="Waterfront Properties" src={imgWaterfront} />
                      </div>
                    </div>
                  </CardImg>
                </Card>
              </Col>
              <Col xs={12} md={4}>
                <Card
                  tag={Link}
                  to={URI('/find-naples-home')
                    .search({
                      communityType:
                        'Golf Bundled,Golf Course,Golf Equity,Golf Non Equity,Golf Public'
                    })
                    .toString()}
                  className={styles.quickSearchCard}
                >
                  <CardBody className={styles.quickSearchCardBody}>
                    <CardTitle>Golf Course Properties</CardTitle>
                  </CardBody>
                  <CardImg tag="div" className={styles.quickSearchCardImg}>
                    <div className={styles.imgWrap}>
                      <div className={styles.imgWrapInner}>
                        <img alt="Golf Course Properties" src={imgGolf} />
                      </div>
                    </div>
                  </CardImg>
                </Card>
              </Col>
              <Col xs={12} md={4}>
                <Card
                  tag={Link}
                  to="/find-naples-home?propertyClass=rental"
                  className={styles.quickSearchCard}
                >
                  <CardBody className={styles.quickSearchCardBody}>
                    <CardTitle>Rental Properties</CardTitle>
                  </CardBody>
                  <CardImg tag="div" className={styles.quickSearchCardImg}>
                    <div className={styles.imgWrap}>
                      <div className={styles.imgWrapInner}>
                        <img alt="Rental Properties" src={imgRental} />
                      </div>
                    </div>
                  </CardImg>
                </Card>
              </Col>
              <Col xs={12}>
                <Card tag={Link} to="/find-community" className={styles.quickSearchCard}>
                  <CardBody className={styles.quickSearchCardBody}>
                    <CardTitle>Naples Area Communities</CardTitle>
                  </CardBody>
                  <CardImg tag="div" className={styles.quickSearchCardImg}>
                    <div className={styles.imgWrap}>
                      <div className={styles.imgWrapInner}>
                        <img alt="Naples Area Communities" src={imgNaples} />
                      </div>
                    </div>
                  </CardImg>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <div className={styles.sponsorsContainer}>
          <Container fluid>
            <h2 className={BS.textCenter}>
              2026 NABOR<sup>®</sup> Corporate Sponsors{' '}
            </h2>
            <ResponsiveCarousel
              className={styles.gallery}
              key="carousel"
              xsNumPerPage={1}
              smNumPerPage={3}
              lgNumPerPage={5}
              placeholderImg="/images/carousel/1x1.png"
              xsClassName={`${BS.col12}`}
              smClassName={`${BS.col4}`}
              printNumPerPage={7}
              itemClassName={styles.galleryItem}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://cottrelltitle.com/"
              >
                <img
                  alt="Cottrell Title"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/cottrell-title-logo.png"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://firptagroup.com/"
              >
                <img
                  alt="The FIRPTA Group"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/The_FIRPTA_Group_Logo.jpg"
                />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.lmcu.org/">
                <img
                  alt="LMCU"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/LMCU_logo.jpg"
                />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://lotteslaw.com/">
                <img
                  alt="Lottes Law Group"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/Lottes_Law_Group.png"
                />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://glpa.law/">
                <img
                  alt="Goodwin Law"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/Goodwin_Law.jpeg"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.saadlegal.com/"
              >
                <img
                  alt="Law Office of Sam J Saad"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/Law_Office_of_Saad_Logo.png"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.cottrelltax.com/"
              >
                <img
                  alt="Cottrell Tax & Accounting"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/Cottrell_Tax_and_Accounting_Logo.png"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://housemaster.com/naples-fort-myers-home-inspection"
              >
                <img
                  alt="HouseMaster"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/HouseMaster.jpg"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.cigflorida.com/"
              >
                <img
                  alt="Chapman Insurance Group"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/Chapman_Insurance_Group_Logo.jpg"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.rosstitle.com/"
              >
                <img
                  alt="Ross Title"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/Ross_Title_Logo.png"
                />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.easymtgs.com/"
              >
                <img
                  alt="Easy Mortgage"
                  className={cx(styles.image, BS.w100)}
                  src="/images/carousel/Easy_Mortgage.jpg"
                />
              </a>
            </ResponsiveCarousel>
          </Container>
        </div>
        <div className={styles.blogContainer}>
          <Container>
            <h2 className={BS.textCenter}>Featured Blog Posts</h2>
            <BlogList featured limit={5} />
            <div className={BS.textCenter}>
              <LinkContainer to="/blog">
                <Button color="link">See All Posts</Button>
              </LinkContainer>
            </div>
          </Container>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { loaded, loading, error, loadStats } = this.props;
    if (!loaded && !loading && !error) {
      loadStats();
    }
  }
}

let handleSubmit = function (query) {
  return routerPush(URI('/find-naples-home').search(query).toString());
};

export default connect(
  (state, props) => ({
    loading: state.Home.get('loading'),
    loaded: state.Home.get('loaded'),
    error: state.Home.get('error'),
    stats: state.Home.get('stats')
  }),
  {
    handleSubmit,
    loadStats
  }
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js